import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../AdminPanel.css";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';

const ViewGroups = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editingGroup, setEditingGroup] = useState(null);
    const [users, setUsers] = useState([]);
    const [editForm, setEditForm] = useState({
        group_id: "",
        group_name: "",
        group_description: "",
        leader_id: "",
        member_ids: []
    });

    const IMAGE_BASE_URL = "https://skcapi.btcjapan.co/user-images/";

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedFname = localStorage.getItem("fname");
        const storedLname = localStorage.getItem("lname");
        
        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserFullName(`${storedFname || ''} ${storedLname || ''}`.trim());
        }
        
        fetchGroups();
        fetchUsers();
    }, [navigate]);

    const fetchGroups = () => {
        setLoading(true);
        fetch("https://skcapi.btcjapan.co/fetch_groups.php")
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setGroups(data.Groups);
                }
            })
            .catch(error => console.error("Error fetching groups:", error))
            .finally(() => setLoading(false));
    };

    const fetchUsers = () => {
        fetch("https://skcapi.btcjapan.co/fetch_users_simple.php")
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setUsers(data.Users);
                }
            })
            .catch(error => console.error("Error fetching users:", error));
    };

    const handleViewGroup = (group) => {
        setSelectedGroup(group);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedGroup(null);
    };

    const handleDeleteGroup = (groupId) => {
        if (window.confirm("Are you sure you want to delete this group? This action cannot be undone!")) {
            setLoading(true);
            fetch("https://skcapi.btcjapan.co/delete_group.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ group_id: groupId })
            })
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    alert("Group deleted successfully!");
                    fetchGroups();
                } else {
                    alert("Error: " + data.Message);
                }
            })
            .catch(error => {
                console.error("Error deleting group:", error);
                alert("Network error occurred");
            })
            .finally(() => setLoading(false));
        }
    };

    const handleEditGroup = (group) => {
        setEditingGroup(group.group_id);
        setEditForm({
            group_id: group.group_id,
            group_name: group.group_name,
            group_description: group.group_description || "",
            leader_id: group.leader_id,
            member_ids: group.members ? group.members.map(m => m.user_id) : []
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEditMemberSelection = (e) => {
        const options = e.target.options;
        const selectedValues = [];
        for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
                selectedValues.push(parseInt(options[i].value));
            }
        }
        setEditForm(prev => ({
            ...prev,
            member_ids: selectedValues
        }));
    };

    const handleSaveEdit = () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("group_id", editForm.group_id);
        formData.append("group_name", editForm.group_name);
        formData.append("group_description", editForm.group_description);
        formData.append("leader_id", editForm.leader_id);
        formData.append("member_ids", JSON.stringify(editForm.member_ids));

        fetch("https://skcapi.btcjapan.co/update_group.php", {
            method: "POST",
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.Status === "200") {
                alert("Group updated successfully!");
                setEditingGroup(null);
                fetchGroups();
            } else {
                alert("Error: " + data.Message);
            }
        })
        .catch(error => {
            console.error("Error updating group:", error);
            alert("Network error occurred");
        })
        .finally(() => setLoading(false));
    };

    const handleCancelEdit = () => {
        setEditingGroup(null);
        setEditForm({
            group_id: "",
            group_name: "",
            group_description: "",
            leader_id: "",
            member_ids: []
        });
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        localStorage.removeItem("user_id");
        localStorage.removeItem("userId");
        navigate("/login");
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
              {userType === "administrator" && <SuperAdminSidebar />}
              {userType === "leader" && <LeaderSidebar />}
              {userType === "manager" && <ManagerSidebar />}
              {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                {/* Use the new AdminNavbar component */}
                <AdminNavbar />

                <div className="main-section">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h3 className="section-title">All Groups</h3>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => navigate("/create-group")}
                        >
                            + Create New Group
                        </button>
                    </div>

                    {loading && <p className="text-center">Loading...</p>}

                    <div className="table-responsive">
                        <table className="table table-striped align-middle">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Group Name</th>
                                    <th>Description</th>
                                    <th>Group Leader</th>
                                    <th>Members</th>
                                    <th>Created Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groups.length > 0 ? (
                                    groups.map((group, index) => (
                                        <React.Fragment key={group.group_id}>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>
                                                    <strong>{group.group_name}</strong>
                                                </td>
                                                <td>
                                                    {group.group_description ? (
                                                        <span className="text-muted" style={{ fontSize: "14px" }}>
                                                            {group.group_description.length > 50 
                                                                ? group.group_description.substring(0, 50) + "..." 
                                                                : group.group_description}
                                                        </span>
                                                    ) : (
                                                        <span className="text-muted">-</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        {group.leader_image ? (
                                                            <img
                                                                src={`${IMAGE_BASE_URL}${group.leader_image}`}
                                                                alt={group.leader_name}
                                                                style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "50%",
                                                                    marginRight: "8px",
                                                                    border: "1px solid #ddd"
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.style.display = "none";
                                                                }}
                                                            />
                                                        ) : (
                                                            <div
                                                                style={{
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    borderRadius: "50%",
                                                                    backgroundColor: "#e9ecef",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    marginRight: "8px",
                                                                    fontSize: "12px",
                                                                    color: "#6c757d"
                                                                }}
                                                            >
                                                                {group.leader_name ? group.leader_name.charAt(0) : "?"}
                                                            </div>
                                                        )}
                                                        <span>{group.leader_name || "N/A"}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="badge bg-info">
                                                        {group.members ? group.members.length : 0}
                                                    </span>
                                                </td>
                                                <td style={{ fontSize: "14px" }}>
                                                    {new Date(group.created_date).toLocaleDateString()}
                                                </td>
                                                <td>
                                                    <div className="btn-group btn-group-sm" role="group">
                                                        <button 
                                                            className="btn btn-info"
                                                            onClick={() => handleViewGroup(group)}
                                                            title="View Details"
                                                        >
                                                            <i className="fas fa-eye"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-warning"
                                                            onClick={() => handleEditGroup(group)}
                                                            disabled={editingGroup === group.group_id}
                                                            title="Edit Group"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button 
                                                            className="btn btn-danger"
                                                            onClick={() => handleDeleteGroup(group.group_id)}
                                                            disabled={loading}
                                                            title="Delete Group"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>

                                            {/* Edit row */}
                                            {editingGroup === group.group_id && (
                                                <tr>
                                                    <td colSpan="7" className="bg-light">
                                                        <div className="p-3">
                                                            <h6 className="mb-3">Edit Group: {group.group_name}</h6>
                                                            <div className="row">
                                                                <div className="col-md-4 mb-2">
                                                                    <label className="form-label">Group Name</label>
                                                                    <input
                                                                        type="text"
                                                                        name="group_name"
                                                                        className="form-control form-control-sm"
                                                                        value={editForm.group_name}
                                                                        onChange={handleEditChange}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-2">
                                                                    <label className="form-label">Description</label>
                                                                    <input
                                                                        type="text"
                                                                        name="group_description"
                                                                        className="form-control form-control-sm"
                                                                        value={editForm.group_description}
                                                                        onChange={handleEditChange}
                                                                    />
                                                                </div>
                                                                <div className="col-md-4 mb-2">
                                                                    <label className="form-label">Leader</label>
                                                                    <select
                                                                        name="leader_id"
                                                                        className="form-select form-select-sm"
                                                                        value={editForm.leader_id}
                                                                        onChange={handleEditChange}
                                                                    >
                                                                        <option value="">Select Leader</option>
                                                                        {users.map(user => (
                                                                            <option key={user.id} value={user.id}>
                                                                                {user.fname} {user.lname}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12 mb-2">
                                                                    <label className="form-label">Members (Hold Ctrl/Cmd to select multiple)</label>
                                                                    <select
                                                                        name="member_ids"
                                                                        className="form-select form-select-sm"
                                                                        multiple
                                                                        value={editForm.member_ids.map(String)}
                                                                        onChange={handleEditMemberSelection}
                                                                        style={{ height: "100px" }}
                                                                    >
                                                                        {users.map(user => (
                                                                            <option key={user.id} value={user.id}>
                                                                                {user.fname} {user.lname} ({user.usertype})
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="mt-2">
                                                                <button 
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={handleSaveEdit}
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? 'Saving...' : 'Save Changes'}
                                                                </button>
                                                                <button 
                                                                    className="btn btn-secondary btn-sm ms-2"
                                                                    onClick={handleCancelEdit}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            {loading ? 'Loading groups...' : 'No groups found. Create your first group!'}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal for viewing group details */}
            {showModal && selectedGroup && (
                <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Group Details: {selectedGroup.group_name}</h5>
                                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <h6>Group Information</h6>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p><strong>Group Name:</strong> {selectedGroup.group_name}</p>
                                            <p><strong>Description:</strong> {selectedGroup.group_description || 'No description'}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <p><strong>Leader:</strong> {selectedGroup.leader_name || 'N/A'}</p>
                                            <p><strong>Created Date:</strong> {new Date(selectedGroup.created_date).toLocaleString()}</p>
                                        </div>
                                    </div>
                                </div>

                                <h6>Members ({selectedGroup.members ? selectedGroup.members.length : 0})</h6>
                                <div className="table-responsive">
                                    <table className="table table-striped table-sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Image</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Role</th>
                                                <th>Added Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedGroup.members && selectedGroup.members.length > 0 ? (
                                                selectedGroup.members.map((member, idx) => (
                                                    <tr key={member.id}>
                                                        <td>{idx + 1}</td>
                                                        <td>
                                                            {member.member_image ? (
                                                                <img
                                                                    src={`${IMAGE_BASE_URL}${member.member_image}`}
                                                                    alt={member.member_name}
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "50%",
                                                                        border: "1px solid #ddd"
                                                                    }}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = "https://via.placeholder.com/40?text=No+Img";
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        width: "40px",
                                                                        height: "40px",
                                                                        borderRadius: "50%",
                                                                        backgroundColor: "#e9ecef",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: "14px",
                                                                        color: "#6c757d"
                                                                    }}
                                                                >
                                                                    {member.member_name ? member.member_name.charAt(0) : "?"}
                                                                </div>
                                                            )}
                                                        </td>
                                                        <td>{member.member_name || 'N/A'}</td>
                                                        <td>{member.member_email || 'N/A'}</td>
                                                        <td>
                                                            <span className={`badge bg-${member.member_type === 'administrator' ? 'danger' : 
                                                                                    member.member_type === 'leader' ? 'warning' : 
                                                                                    member.member_type === 'manager' ? 'primary' : 'secondary'}`}>
                                                                {member.member_type || 'member'}
                                                            </span>
                                                        </td>
                                                        <td style={{ fontSize: "13px" }}>
                                                            {new Date(member.added_date).toLocaleDateString()}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">No members in this group</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewGroups;